import cx from "classnames";

import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import { RUN_OBSERVABILITY_FINDING_SEVERITIES } from "./constants";
import styles from "./styles.module.css";
import { RunObservabilityFinding } from "./types";

const RunObservabilityFindingsRow = ({
  severity,
  title,
  description,
  recommendation,
}: RunObservabilityFinding) => {
  const { banner, chip } = RUN_OBSERVABILITY_FINDING_SEVERITIES[severity];

  return (
    <Banner variant={banner} title={title}>
      {(description || recommendation) && (
        <Box direction="column" align="start" gap="medium">
          {description}

          {recommendation && (
            <Box padding="small medium" className={cx(styles.recommendation, chip)}>
              <Typography tag="p" variant="p-body3-multiline">
                <Typography tag="span" variant="p-t7">
                  Recommendations:
                </Typography>{" "}
                {recommendation}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Banner>
  );
};

export default RunObservabilityFindingsRow;
